module.exports = __webpack_public_path__ + "static/media/bloo-icon-pink.d27d3ad3.svg";